module.exports = __webpack_public_path__ + "67306cf1af5e95b0f10fd39433ac14af.png";